/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Provider_ThrottledInputs */



/**
* | output |
* | --- |
* | "The provider rate-limited this connection, so the last sync stopped early instead of retrying. It continues on the next sync." |
*
* @param {Sync_Degraded_Provider_ThrottledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_provider_throttled = /** @type {((inputs?: Sync_Degraded_Provider_ThrottledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Provider_ThrottledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Anbieter hat diese Verbindung gedrosselt; die letzte Synchronisierung wurde deshalb früh beendet statt es erneut zu versuchen. Sie wird bei der nächsten Synchronisierung fortgesetzt.")
	return /** @type {LocalizedString} */ ("The provider rate-limited this connection, so the last sync stopped early instead of retrying. It continues on the next sync.")
});